(function () {
	// Initialize an empty object or use an existing one
	var LacrmEmbedParams, ParamNames;
	ParamNames = LacrmEmbedParams || (LacrmEmbedParams = {});

	// Define various properties for the object
	ParamNames.Height = "height";
	ParamNames.Embed = "embed";
	ParamNames.ShowHeader = "show-header";

	// CSS selector for embed elements
	const EmbedSelector = "." + ["lacrm-embed"].join(", .");

	// Constants for warnings and limits
	const WarningPrefix = "[Less Annoying Forms Embed.js embed script]";

	// Get data attributes for various properties
	const HeightAttr = GetDataAttributeName(LacrmEmbedParams.Height);
	const ShowHeaderAttr = GetDataAttributeName(LacrmEmbedParams.ShowHeader);

	// Function to generate data-attribute name based on property
	function GetDataAttributeName(AttributeName) {
		return "data-embed-".concat(AttributeName);
	}

	// Function to copy an array up to a specified length
	function CopyArray(ArrayToCopy, MaxLength) {
		if (null === MaxLength || MaxLength > ArrayToCopy.length) {
			MaxLength = ArrayToCopy.length;
		}
		const Result = [];
		for (let i = 0; i < MaxLength; i++) {
			Result[i] = ArrayToCopy[i];
		}
		return Result;
	}

	// Various helper functions for array handling
	function ConvertArray(ArrayToConvert) {
		if (Array.isArray(ArrayToConvert)) {
			return CopyArray(ArrayToConvert);
		}
	}

	function ConvertIterable(IterableToConvert) {
		if (
			(typeof Symbol !== "undefined" &&
				IterableToConvert[Symbol.iterator] != null) ||
			IterableToConvert["@@iterator"] != null
		) {
			return Array.from(IterableToConvert);
		}
	}

	function ThrowTypeError() {
		throw new TypeError(
			"Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
		);
	}

	function ConvertToArray(PotentialArray, Length) {
		if (!PotentialArray) {
			return;
		}

		if (typeof PotentialArray === "string") {
			return CopyArray(PotentialArray, Length);
		}
		let Type = Object.prototype.toString.call(PotentialArray).slice(8, -1);
		if ("Object" === Type && PotentialArray.constructor) {
			Type = PotentialArray.constructor.name;
		}
		if (["Map", "Set"].includes(Type)) {
			return Array.from(PotentialArray);
		}
		if (
			["Arguments"].includes(Type) ||
			/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Type)
		) {
			return CopyArray(PotentialArray, Length);
		}
	}

	function SpreadArray(Input) {
		return (
			ConvertArray(Input) ||
			ConvertIterable(Input) ||
			ConvertToArray(Input) ||
			ThrowTypeError()
		);
	}

	// Helper function to check if a value is a boolean represented as a string
	function IsBooleanString(Value) {
		return Value === "true" || Value === "false";
	}

	// Function to log warnings
	function LogWarning(Value, Parameter, AdditionalMessage) {
		let Message = ""
			.concat(WarningPrefix, " warning: unexpected ")
			.concat(Parameter, " parameter: ")
			.concat(Value);
		if (AdditionalMessage) {
			Message += ", ".concat(AdditionalMessage, ".");
		}
		console.log(Message);
	}

	// Validation function for embed parameters
	function ValidateEmbedParams(EmbedParams) {
		const { ShowHeader } = EmbedParams;

		if (ShowHeader && !IsBooleanString(ShowHeader)) {
			LogWarning(ShowHeader, LacrmEmbedParams.ShowHeader);
		}
	}

	// Regex patterns for URL
	const HttpRegex = /^https?:\/\//i;
	const FormIdRegex = /\/(?:view)\/(\d+)\/?$/;

	// Function to construct an embed URL with query parameters
	function ConstructEmbedUrl(Element, BaseUrl) {
		const ShowHeader = Element.getAttribute(ShowHeaderAttr) || "true";
		const ParentInfo = GetParentPageInfo();
		const EncodedParentInfo = encodeURIComponent(JSON.stringify(ParentInfo));

		// Validate the embed parameters
		ValidateEmbedParams({
			ShowHeader,
		});

		const QueryParams = "&"
			.concat(LacrmEmbedParams.Embed, "=true&")
			.concat("ShowHeader", `=${ShowHeader}&`)
			.concat("ParentInfo", `=${EncodedParentInfo}`);
		return BaseUrl + QueryParams;
	}

	function GetParentPageInfo() {
		return {
			Url: window.location.href,
			InnerWidth: window.innerWidth,
			UserAgent: navigator.userAgent
		};
	}

	// Extract pathname from a URL if it matches the expected format
	function ExtractPathname(AnchorElement) {
		const Href = AnchorElement.href;
		const Pathname = AnchorElement.pathname;

		if (HttpRegex.test(Href) && FormIdRegex.test(Pathname)) {
			const FormId = Pathname.replace("/view/", "");
			const EmbedHref = AnchorElement.host.replace("forms", "embed");
			return `https://${EmbedHref}/?FormId=${FormId}`;
		}
	}

	// Generate an embed URL for an element
	function GenerateEmbedUrlForElement(Element) {
		const EmbedUrl = GenerateEmbedUrlFromLinks(
			Element.tagName === "A"
				? [Element]
				: SpreadArray(Element.getElementsByTagName("a"))
		);

		if (EmbedUrl) {
			return ConstructEmbedUrl(Element, EmbedUrl);
		}
	}

	// Generate an embed URL based on links
	function GenerateEmbedUrlFromLinks(Links) {
		for (let i = 0; i < Links.length; i++) {
			const ValidatedHref = ExtractPathname(Links[i]);
			if (ValidatedHref) {
				return ValidatedHref;
			}
		}
	}

	// Main function to handle embedding logic
	function InitializeLacrmFormEmbed() {
		const Elements = document.querySelectorAll(EmbedSelector);

		if (Elements.length) {
			for (let Index = 0; Index < Elements.length; Index++) {
				HandleElementEmbedding(Elements[Index]);
			}
		}
	}

	// Handle embedding logic for a specific element
	function HandleElementEmbedding(Element) {
		if (!Element || !Element.parentNode) {
			return;
		}

		const EmbedUrl = GenerateEmbedUrlForElement(Element);
		if (!EmbedUrl) {
			return;
		}

		// Create an iframe for the embed
		const Iframe = CreateIframe(EmbedUrl, Element.getAttribute(HeightAttr));
		window.addEventListener("message", function (Event) {
			HandleResizeMessage(Event, Iframe);
		});

		// Insert the iframe before the current element
		Element.parentNode.insertBefore(Iframe, Element);
		Element.parentNode.removeChild(Element);
	}

	// Function to create an iframe with given attributes
	function CreateIframe(Src, Height) {
		const Iframe = document.createElement("iframe");

		if (Height) {
			Iframe.setAttribute("height", FormatHeight(Height));
		}

		Iframe.setAttribute("src", Src);
		Iframe.setAttribute("width", "100%");
		Iframe.setAttribute("scrolling", "no");
		Iframe.setAttribute("allowfullscreen", "true");
		Iframe.setAttribute(
			"sandbox",
			"allow-scripts allow-same-origin allow-popups allow-forms"
		);
		Iframe.setAttribute("allow", "clipboard-read; clipboard-write");
		Iframe.style.border = "none";
		Iframe.style.maxWidth = "100%";
		Iframe.style.display = "block";
		Iframe.style.margin = "0 auto";
		Iframe.style.borderRadius = "8px";
		return Iframe;
	}

	// Format the height value for the iframe
	function FormatHeight(Height) {
		const HeightString = "".concat(Height);
		return HeightString.endsWith("px")
			? HeightString
			: HeightString.concat("px");
	}

	// Handle resize messages for the iframe
	function HandleResizeMessage(Event, Iframe) {
		if (Iframe.contentWindow === Event.source) {
			let MessageData;
			if (typeof Event.data === "string" && Event.data) {
				try {
					MessageData = JSON.parse(Event.data);
				} catch (error) {
					console.error(
						"".concat(
							WarningPrefix,
							" error: Couldn't parse message from event: "
						),
						error
					);
				}
			} else {
				MessageData = Event.data;
			}

			if (MessageData && MessageData.type === "EmbedResize") {
				const NewHeight = MessageData.Height;
				Iframe.setAttribute("height", "".concat(NewHeight));
				Iframe.setAttribute("scrolling", "no");
			} else if (MessageData && MessageData.type === "FormSubmission") {
				window.scrollTo({
					top: MessageData.FormTop,
					behavior: "smooth",
				});
			}
		}
	}

	// Execute the main embedding logic
	try {
		InitializeLacrmFormEmbed();
	} catch (error) {
		console.log("".concat(WarningPrefix, " error: "), error);
	}
})();